import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { jsonGet } from '../api';
import { GalleryImage } from '../models/galleryImage';

type SliceModel = GalleryImage;
const sliceName: string = 'galleryImages';

const currRequests: Set<ModelId> = new Set;

export const fetchGalleryImage = createAsyncThunk(
    sliceName + '/fetchById',
    async (id: ModelId) => {
        if (currRequests.has(id)) {
            return null;
        } else {
            currRequests.add(id);
            return await jsonGet<SliceModel>('/data/' + sliceName + '/' + id);
        }
    }
);

export const galleryImageAdapter = createEntityAdapter<SliceModel>({
    selectId: (attrs: SliceModel) => attrs.id
});
export const galleryImageSlice = createSlice({
    name: sliceName,
    initialState: galleryImageAdapter.getInitialState(),
    reducers: {
        addMany: galleryImageAdapter.addMany,
        addOne: galleryImageAdapter.addOne,
        updateMany: galleryImageAdapter.updateMany,
        updateOne: galleryImageAdapter.updateOne,
        upsertOne: galleryImageAdapter.upsertOne,
        upsertMany: galleryImageAdapter.upsertMany,
        removeOne: galleryImageAdapter.removeOne
    },
    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        builder.addCase(fetchGalleryImage.fulfilled, (state, action) => {
            if (action.payload) {
                currRequests.delete(action.payload.id);
                galleryImageAdapter.upsertOne(state, action.payload);
            }
        });
    },
});
